import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-u",
  "use": "arrow-u-usage",
  "viewBox": "0 0 20 11.1",
  "content": "<symbol viewBox=\"0 0 20 11.1\" id=\"arrow-u\">\n<title>arrow-d</title>\n<path d=\"M9,0.5C9.3,0.2,9.6,0,10,0c0.4-0.1,0.7,0.2,1,0.5l8.7,8.7c0.4,0.4,0.4,1.2,0,1.6s-1.2,0.4-1.6,0L10,2.5l-8.1,8.3\n\tc-0.4,0.4-1.2,0.4-1.6,0s-0.4-1.2,0-1.6L9,0.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/arrow-u.svg
// module id = 5EjI
// module chunks = 264